import camelCase from 'lodash/camelCase';
import Logger from '@/lib/logger';

/**
 * Autoloads root vuex modules into an object.
 * Each modules are mapped in the object as the camelCased file name without the extension
 * For example:
 *  If the filename for the store module is app.module.js
 *  Then the module name is "appModule"
 *  Hence the mapping is
 *  {
 *    appModule: {
 *        namespaced: true,
 *        state: {},
 *        getters: {},
 *        mutations: {},
 *        actions:{}
 *    }
 *  }
 *  This therefore can be used throught the project as follows:
 *  import { mapGetters } from "vuex";
 *  export default {
 *    ...
 *    computed: {
 *       ...mapGetters("appModule", ["the name of the getter here"])
 *    }
 *    ...
 *  }
 *
 * @returns { Object } modules
 */
function loadVuexModules() {
  // create a variable to hold all modules that will be created
  const modules = {};
  // const moduleFiles = require.context('@/', true, /\.module\.js$/);
  const moduleFiles = import.meta.glob('@/**/*.module.js', { eager: true });
  for (const path in moduleFiles) {
    const moduleName = camelCase(
      path
        .replace(/^\.\//g, '') // Remove './' from the beginning of the file path
        .replace(/\.module\.js$/g, '') // Remove '.module.js' from the end of the file path
        .split('/') // Split the file path by '/'
        .pop() // Take the last part of the path
        //add Module to the end of the file name
        .concat('Module')
    );
    try {
      Logger.info(`${moduleName} Loaded`);
      const store = moduleFiles[path].default || moduleFiles[path];
      modules[moduleName] = {
        namespaced: true,
        ...store
      };
    } catch (e) {
      Logger.error('Unable to load root store module: ', moduleName, e);
    }
  }

  return modules;
}

export { loadVuexModules };
